import * as React from 'react';
import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import { isEmpty } from 'ramda';
import { useSelector } from 'react-redux';

import { PricesDynamicsContainer } from './containers/PricesDynamicsContainer';
import { trackRealtyValuationInView } from './tracking';
import { RealtyValuation } from '../../components/RealtyValuation';
import { selectDeveloperValuationData } from '../../selectors/developerValuation';
import { Responsive } from '@cian/ui-kit';
import { RealtyValuationMobileContainer } from './RealtyValuationMobileContainer';
import { RealtyValuationMobile } from '../../components/RealtyValuation/RealtyValuationMobile';

export function RealtyValuationContainer() {
  const realtyValuation = useSelector(selectDeveloperValuationData);

  const isRealtyValuationAvailable = React.useMemo(() => {
    if (!realtyValuation || isEmpty(realtyValuation)) {
      return false;
    }

    return realtyValuation.filters.availableRegionIds.length > 0;
  }, [realtyValuation]);

  if (!isRealtyValuationAvailable) {
    return null;
  }

  return (
    <ActionAfterViewObserver callback={trackRealtyValuationInView} triggerOnce>
      <>
        <Responsive desktop>
          <RealtyValuation title="Динамика цен" content={<PricesDynamicsContainer />} />
        </Responsive>
        <Responsive phone tablet>
          <RealtyValuationMobile title="Уровень цен" content={<RealtyValuationMobileContainer />} />
        </Responsive>
      </>
    </ActionAfterViewObserver>
  );
}
